const FACEBOOK_DOMAIN_VERIFICATION = '6zg93ma3u6p484y0r8kiazazs5nsrh'

export function injectFacebookDomainVerification() {
  if (typeof document === 'undefined') return

  const selector = 'meta[name="facebook-domain-verification"]'
  const existing = document.head.querySelector<HTMLMetaElement>(selector)

  if (existing) {
    existing.content = FACEBOOK_DOMAIN_VERIFICATION
    return
  }

  const meta = document.createElement('meta')
  meta.name = 'facebook-domain-verification'
  meta.content = FACEBOOK_DOMAIN_VERIFICATION
  document.head.appendChild(meta)
}
